import { IRouteData, NotFoundPage, PageProvider } from '@tap/tap-ui';
import { HomePage } from '../features/home/HomePage';
import { IssueListPage } from '../features/issue/IssueListPage';
import { AppBasePath } from '../env';
import { IssueSearchPage } from '../features/issue/IssueSearchPage';
import { AnalyticsPage } from '../features/analytics/AnalyticsPage';
import ComparisonOfStatisticsPage from '../features/analytics/comparison-of-statistics/ComparisonOfStatisticsPage';
import AverageAgePage from '../features/analytics/average-age/AverageAgePage';
import { RecentlyCreatedIssuesPage } from '../features/analytics/recently-created-issues/RecentlyCreatedIssuesPage';
import IssuePieChartByAssigneePage from '../features/analytics/pie-chart-report/IssuePieChartByAssigneePage';
import IssueDecisionTimePage from '../features/analytics/decision-time/IssueDecisionTimePage';
import IssueCreatedAndResolvedTaskComparisonPage from '../features/analytics/task-comparison/IssueCreatedAndResolvedTaskComparisonPage';
import IssueUploadingUsersPage from '../features/analytics/uploading-users/IssueUploadingUsersPage';
import IssueTimeSpentPage from '../features/analytics/time-spent/IssueTimeSpentPage';
import { documentPageRouteParams, IssueDocumentCode } from '@tap/doc-ui';
import { DetailsPageRoutes } from '../DetailsPageRoutes';
import PersonalWorkReportByIssuePage from '../features/analytics/output-by-day/PersonalWorkReportByIssuePage';
import IssueStatisticOnWorkersReportPage from '../features/analytics/statistic-on-workers/IssueStatisticOnWorkersReportPage';
import { InputDataPage } from '../features/input-data/InputDataPage';
import EmptyPage from '@tap/tap-ui/src/pages/EmptyPage';

const ANALYTICS = '/analytics';
const INPUTDATA = '/input-data';

export const RoutesData: IRouteData = {
    home: {
        isHome: true,
        label: 'Главная',
        component: <HomePage title={'Главная'} />,
        path: AppBasePath + '/',
    },
    qcTaskList: {
        label: 'Контроль качества',
        component: <IssueListPage
            issueCodes={[IssueDocumentCode.QC]}
            key={'qcPage'} />,
        path: AppBasePath + '/qc',
    },
    ugmTaskList: {
        label: 'Управление оборудованием',
        component: <IssueListPage
            issueCodes={[IssueDocumentCode.UGM]}
            key={'ugmPage'} />,
        path: AppBasePath + '/ugm',
    },
    toolTaskList: {
        label: 'Инструменты и СТО',
        component: <IssueListPage
            issueCodes={[IssueDocumentCode.TOOL]}
            key={'toolPage'} />,
        path: AppBasePath + '/tool',
    },
    wipTaskList: {
        label: 'НЗП и готовые материалы',
        component: <IssueListPage
            issueCodes={[IssueDocumentCode.WIP]}
            key={'wipPage'} />,
        path: AppBasePath + '/wip',
    },
    techTaskList: {
        label: 'Технология',
        component: <IssueListPage
            issueCodes={[IssueDocumentCode.TECH]}
            key={'techPage'} />,
        path: AppBasePath + '/tech',
    },
    allTask: {
        label: 'Все заявки',
        component: <IssueSearchPage title={'Все заявки'} />,
        path: AppBasePath + '/all-tasks',
    },
    inputDataPage: {
        label: 'Входные данные',
        component: <InputDataPage />,
        path: AppBasePath + INPUTDATA,
    },
    defectsPage: {
        label: 'Дефекты',
        component: <EmptyPage title='Дефекты' />,
        path: AppBasePath + INPUTDATA + '/defects',
    },
    analytics: {
        label: 'Аналитика и отчёты',
        component: <AnalyticsPage title='Аналитика и отчёты' />,
        path: AppBasePath + ANALYTICS,
    },
    issueAverageAgePage: {
        label: 'Средняя длительность незавершённых заявок',
        component: <AverageAgePage title='Средняя длительность незавершённых заявок' />,
        path: AppBasePath + ANALYTICS + '/average-age',
    },
    issueTaskComparison: {
        label: 'Созданные vs Завершённые заявки',
        component: <IssueCreatedAndResolvedTaskComparisonPage title='Созданные vs Завершённые заявки' />,
        path: AppBasePath + ANALYTICS + '/issue-task-comparison',
    },
    issuePieChartPage: {
        label: 'Круговая диаграмма',
        component: <IssuePieChartByAssigneePage title='Круговая диаграмма' />,
        path: AppBasePath + ANALYTICS + '/issue-pie-chart-by-assignee',
    },
    issueRecentlyCreatedTasks: {
        label: 'Недавно созданные заявки',
        component: <RecentlyCreatedIssuesPage />,
        path: AppBasePath + ANALYTICS + '/recently-created-issues',
    },
    issueDecisionTimePage: {
        label: 'Время на решение заявок',
        component: <IssueDecisionTimePage title='Время на решение заявок' />,
        path: AppBasePath + ANALYTICS + '/issue-decision-time',
    },
    issueComparisonOfStatistics: {
        label: 'План-факт',
        component: <ComparisonOfStatisticsPage title='План-факт' />,
        path: AppBasePath + ANALYTICS + '/comparison-of-statistics',
    },
    issueUploadingUsersPage: {
        label: 'Загрузка пользователя',
        component: <IssueUploadingUsersPage title='Загрузка пользователя' />,
        path: AppBasePath + ANALYTICS + '/issue-uploading-users',
    },
    issueOutputByDayPage: {
        label: 'Персональная выработка по дням',
        component: <PersonalWorkReportByIssuePage />,
        path: AppBasePath + ANALYTICS + '/output_by_day',
    },
    issueStatisticsOnPerformersPage: {
        label: 'Статистика по исполнителям',
        component: <IssueStatisticOnWorkersReportPage title='Статистика по исполнителям' />,
        path: AppBasePath + ANALYTICS + '/statistics-on-performers',
    },
    issueTimeSpentPage: {
        label: 'Затраченное время',
        component: <IssueTimeSpentPage title='Затраченное время' />,
        path: AppBasePath + ANALYTICS + '/issue-time-spent',
    },
    detailsPageRoutes: {
        label: 'Детальная информация',
        component: <PageProvider zodRouteParams={documentPageRouteParams} Page={DetailsPageRoutes} />,
        path: '/:documentKey',
        labelTypeInBreadcrumbs: 'DOCUMENT_DETAILS_PAGE',
    },
    notFound: {
        label: 'Такой страницы не существует!',
        component: <NotFoundPage />,
        path: '*',
    },
}
